import * as React from "react";
import type { SVGProps } from "react";
const SvgGrid01 = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      stroke="#000"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth={2}
      d="M19.467 2.4c1.178 0 2.133.942 2.133 2.104v3.592c0 1.162-.955 2.104-2.133 2.104h-3.2c-1.178 0-2.134-.942-2.134-2.104V4.504c0-1.162.956-2.104 2.134-2.104zM4.533 2.4C3.355 2.4 2.4 3.342 2.4 4.504v3.592c0 1.162.955 2.104 2.133 2.104h3.2c1.179 0 2.134-.942 2.134-2.104V4.504c0-1.162-.955-2.104-2.134-2.104zM19.467 13.8c1.178 0 2.133.942 2.133 2.104v3.592c0 1.162-.955 2.104-2.133 2.104h-3.2c-1.178 0-2.134-.942-2.134-2.104v-3.592c0-1.162.956-2.104 2.134-2.104zM4.533 13.8c-1.178 0-2.133.942-2.133 2.104v3.592c0 1.162.955 2.104 2.133 2.104h3.2c1.179 0 2.134-.942 2.134-2.104v-3.592c0-1.162-.955-2.104-2.134-2.104z"
    />
  </svg>
);
export default SvgGrid01;
